<template>
  <FormKit
    :key="`selectedPaymentFrequency-${paymentStore.selectedPaymentFrequencyDisplayText}`"
    v-model="paymentStore.selectedPaymentFrequencyDisplayText"
    name="selectedPaymentFrequency"
    type="racqDropdown"
    :outerClass="outerClass ?? 'mt-3 mb-6'"
    classesOptions="dropdown-sm text-m-bold"
    :options="options"
  >
  </FormKit>
</template>

<script lang="ts">
export const emitPaymentFrequencyChanged = 'paymentFrequencyChanged';
</script>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { usePaymentStore } from '@/store';
import { IDropdownItem, PaymentFrequency } from '@/interfaces';

const props = defineProps<{
  outerClass?: string;
}>();

const paymentStore = usePaymentStore();
const options = ref<IDropdownItem[]>();

onMounted(() => {
  if (paymentStore.paymentFrequencyWording) {
    options.value = [
      { label: paymentStore.paymentFrequencyWording?.monthly, value: paymentStore.paymentFrequencyWording?.monthly },
      { label: paymentStore.paymentFrequencyWording?.annual, value: paymentStore.paymentFrequencyWording?.annual },
    ];

    paymentStore.selectedPaymentFrequencyDisplayText =
      paymentStore.selectedPaymentFrequency == PaymentFrequency.Annually
        ? paymentStore.paymentFrequencyWording?.annual
        : paymentStore.paymentFrequencyWording?.monthly;
  }
});
</script>
